/**
 * Que NO es un error de verdad para el monitor (ruido del navegador) y que
 * puede ser solo un reinicio del servidor (un despliegue) y conviene confirmar
 * antes de reportarlo.
 */

/** Avisos del navegador que no rompen nada y no se pueden corregir desde la pagina. */
const BENIGN_MESSAGES = [
  // Chrome lo lanza cuando un ResizeObserver (graficas, textareas) cambia el tamaño
  // dentro de su propio aviso; la especificacion lo define como inofensivo.
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/i,
  // El navegador cancela una transicion de vista si la pestaña se oculta a mitad.
  /Transition was (aborted|skipped)/i,
];

export function isBenignBrowserError(error: unknown): boolean {
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : String((error as { message?: unknown })?.message ?? '');
  return BENIGN_MESSAGES.some((re) => re.test(message));
}

/** Una llamada al API rechazada: el interceptor ya la reporto (o es un 4xx esperado). */
export function isAxiosRejection(error: unknown): boolean {
  return !!error && typeof error === 'object' && (error as { isAxiosError?: unknown }).isAxiosError === true;
}

/**
 * Sin respuesta (red) o 502/503/504: lo normal mientras el servidor se reinicia
 * en un despliegue. Se reporta solo si sigue fallando un rato despues.
 */
export function isPossibleRestart(status: number | undefined): boolean {
  return status === undefined || status === 502 || status === 503 || status === 504;
}
